import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { SearchNotOrdered, Status } from "./types";
import { fCurrency } from "../utils/formatNumber";
import { CloseIcon } from "../../minimals/theme/overrides/CustomIcons";
import { processSearchStatuses } from "./processSearchStatuses";
import { useSearchesNotOrdered } from "./SearchesNotOrderedContext";
import { DatePicker } from "@mui/x-date-pickers";

interface IProps {
  entity: SearchNotOrdered;
  setEntity: Function;
  setEntityTable?: Function;
  isOpen: boolean;
  orderNumberDisplay?: string;
  amount?: string;
  priority?: string;
  refetchData?: Function;
  statusOptions: Status[];
}

export default function EditETAModal({ entity, setEntity, orderNumberDisplay, amount, isOpen }: IProps) {
  const { setSearchesNotOrdered, searchesNotOrdered } = useSearchesNotOrdered();
  const [submitting, setSubmitting] = useState(false);
  const [selectedETA, setSelectedETA] = useState<Date | null>(entity.eta ? new Date(entity.eta) : null);

  const saveETA = async () => {
    await axios.post("/proxy/api/requestedtasks/update", {
      orderNumber: entity.orderNumber,
      task: {
        description: "County Search",
        dueDate: selectedETA
      }
    });
    updateSelectedEntity();
  };

  const updateSelectedEntity = () => {
    if (!entity) return;
    const updatedEntity = {
      ...entity,
      eta: selectedETA
    } as SearchNotOrdered;
    const updatedData = processSearchStatuses(
      searchesNotOrdered.map((s) => (s.orderNumberWithPrefix === entity.orderNumberWithPrefix ? updatedEntity : s))
    );

    setSearchesNotOrdered(updatedData);

    setEntity(null);
  };

  const save = async () => {
    if (!entity) return;
    setSubmitting(true);
    await saveETA().catch(() => setSubmitting(false));
    setSubmitting(false);
  };

  const onClose = () => setEntity(null);

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Stack direction="row" spacing={2} alignItems="center" marginBottom={3}>
          <Box>
            Order Number {orderNumberDisplay || entity.orderNumber}
            {amount ? ` - ${fCurrency(amount)}` : ""}
          </Box>
        </Stack>
      </DialogTitle>
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ paddingBottom: 3 }}>
        <Box paddingTop={1}>
          <DatePicker value={selectedETA} onChange={setSelectedETA} />
          <Stack direction="row" justifyContent="right" marginTop={2}>
            <Button variant="contained" size="small" onClick={save} disabled={submitting}>
              {submitting ? "Saving..." : "Save"}
            </Button>
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
